export default "__VITE_ASSET__6eeb39ac__"